
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-abcanalyse-list-view',
  imports: [],
  templateUrl: './abcanalyse.list-view.html',
  styleUrls: ['./abcanalyse.list-view.css'],
})
export class AbcAnalyseListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
